<template>
  <div class="payContainer">
    <div class="payContent">
      <el-form label-width="140px"
               :model="payForm">
        <el-form-item :label="(reportType && fileType)?'报告类型':'会员类型'"
                      class="myItem">

          <template v-for="item in priceList">
            <el-radio class="priceRadio"
                      @change="curPrice=item"
                      :key="item.id"
                      v-model="payForm.tableId"
                      :label="item.id"
                      border>
              <el-tooltip placement="top"
                          effect="light">
                <div slot="content">
                  <h4 style="border-left:5px solid #5A3995">&nbsp;购买须知：</h4>
                  <template v-if="parseInt(item.limitCount)!==1">
                    <p>1.{{item.packageName}}使用期限为{{item.time}}天,购买成功即开始计算时间；</p>
                    <p>2.购买成功后，该{{item.packageName}}可供当前账户在CSMAR智能财经报告模块下载{{item.limitCount}}份报告，使用完毕后可继续购买单份报告或其他套餐；</p>
                    <p>3.由于智能财经报告是特殊商品，购买前请确认内容，一旦购买，概不退款。</p>
                  </template>
                  <template v-else>
                    <p>1.由于智能财经报告是特殊商品，购买前请确认内容，一旦购买，概不退款。</p>
                    <p>2.购买成功后，仅可下载当前报告，下载完毕后可继续购买其他单份报告或套餐。</p>
                  </template>
                </div>
                <i class="el-icon-question"
                   style="position:absolute;right:0"></i>
              </el-tooltip>
              <h3>{{item.packageName}}</h3>
              <b class="price">{{(parseInt(item.price)/100).toFixed(2)}}</b>元
            </el-radio>
          </template>

        </el-form-item>
        <el-form-item label="支付方式"
                      class="myItem">
          <!-- <el-radio class="payRadio"
                    v-model="payForm.paymentType"
                    label="1"
                    border>
            <img src="../assets/imgs/alipay.png"
                 width="100px" />
          </el-radio> -->
          <el-radio class="payRadio"
                    v-model="payForm.paymentType"
                    label="2"
                    border>
            <img src="../assets/imgs/wxpay.png"
                 width="100px" />
          </el-radio>
        </el-form-item>
        <!-- <el-form-item label="发票需求">
          <el-radio v-model="payForm.isInvoiceOrnot"
                    label="0">否</el-radio>
          <el-radio v-model="payForm.isInvoiceOrnot"
                    label="1">是</el-radio>
          <span style="color:gray;font-size:12px;"> （开具发票金额为实际支付金额，低于500元时，纸质版发票需支付22元运费）</span>
        </el-form-item> -->

      </el-form>
      <template v-if="payForm.isInvoiceOrnot==='1'">
        <el-form label-width="140px"
                 :model="invoiceForm">
          <el-form-item label="发票类型">
            <el-radio v-model="invoiceForm.invoiceType"
                      label="0">增值税普通发票（纸质）</el-radio>
            <el-radio v-model="invoiceForm.invoiceType"
                      label="2"> 增值税普通发票 (电子版）</el-radio>
            <el-radio v-model="invoiceForm.invoiceType"
                      label="1">增值税专用发票（纸质）</el-radio>

          </el-form-item>
          <template v-if="invoiceForm.invoiceType==='0'">
            <el-form-item label="发票抬头"
                          :required="true">
              <el-input v-model="invoiceForm.invoiceTitle"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号"
                          :required="true">
              <el-input v-model="invoiceForm.registrationNumber"></el-input>
            </el-form-item>
            <el-form-item label="收货人姓名"
                          :required="true">
              <el-input v-model="invoiceForm.consigneeName"></el-input>
            </el-form-item>
            <el-form-item label="收货人联系电话"
                          :required="true">
              <el-input v-model="invoiceForm.consigneePhoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="发票邮寄地址"
                          :required="true">
              <el-input v-model="invoiceForm.mailingAddress"></el-input>
            </el-form-item>
          </template>
          <template v-if="invoiceForm.invoiceType==='2'">
            <el-form-item label="联系电话"
                          :required="true">
              <el-input v-model="invoiceForm.consigneePhoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="邮箱"
                          :required="true">
              <el-input v-model="invoiceForm.mailingAddress"></el-input>
            </el-form-item>
            <el-form-item label="发票抬头"
                          :required="true">
              <el-input v-model="invoiceForm.invoiceTitle"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号"
                          :required="true">
              <el-input v-model="invoiceForm.registrationNumber"></el-input>
            </el-form-item>
          </template>
          <template v-if="invoiceForm.invoiceType==='1'">
            <el-form-item label="发票抬头"
                          :required="true">
              <el-input v-model="invoiceForm.invoiceTitle"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号"
                          :required="true">
              <el-input v-model="invoiceForm.registrationNumber"></el-input>
            </el-form-item>
            <el-form-item label="开户行名称"
                          :required="true">
              <el-input v-model="invoiceForm.bankName"></el-input>
            </el-form-item>
            <el-form-item label="税务登记开票地址"
                          :required="true">
              <el-input v-model="invoiceForm.taxAddress"></el-input>
            </el-form-item>
            <el-form-item label="开户行帐号"
                          :required="true">
              <el-input v-model="invoiceForm.bankAccount"></el-input>
            </el-form-item>
            <el-form-item label="座机号码"
                          :required="true">
              <el-input v-model="invoiceForm.landlineNumber"></el-input>
            </el-form-item>
            <el-form-item label="收货人姓名"
                          :required="true">
              <el-input v-model="invoiceForm.consigneeName"></el-input>
            </el-form-item>
            <el-form-item label="收货人联系电话"
                          :required="true">
              <el-input v-model="invoiceForm.consigneePhoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="发票邮寄地址"
                          :required="true">
              <el-input v-model="invoiceForm.mailingAddress"></el-input>
            </el-form-item>
          </template>

        </el-form>
      </template>
      <div style="clear:both:height:20px"></div>
    </div>
    <div class="payFooter">
      <el-button type="primary"
                 @click="toPay">去支付（
        <template v-if="(this.payForm.isInvoiceOrnot === '1')
                  &&(invoiceForm.invoiceType ==='0' ||  invoiceForm.invoiceType ==='1')
                    &&(curPrice.price < 50000)">
          {{((parseInt(curPrice.price) + 2200)/100).toFixed(2)}}
        </template>
        <template v-else>
          {{(parseInt(curPrice.price)/100).toFixed(2)}}
        </template>
        元）</el-button>
    </div>

    <el-dialog title="支付"
               :visible.sync="ercodeDialogVisible"
               width="388px"
               center
               append-to-body>
      <img v-if="ercodeContent.type==='img'"
           :src="ercodeContent.data"
           style="width: 80%;left: 10%;position: relative;" />
      <iframe v-if="ercodeContent.type==='url'"
              :src="iframeUrl"
              style="width: 320px;height: 280px;overflow: hidden;border: 0;" />
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'pay',
  props: ['fileType', 'reportType', 'reportId'],
  data () {
    return {
      priceList: [],
      payForm: {
        paymentType: '2',
        isInvoiceOrnot: '0'
      },
      invoiceForm: {
        invoiceType: '0'
      },
      curPrice: {},
      logPriceId: '',
      ercodeDialogVisible: false,
      ercodeContent: '',
      orderTimer: null,
      iframeUrl: ''
    }
  },
  computed: {

  },
  mounted: function () {
    this.loadPriceList()
  },
  watch: {

  },
  methods: {
    loadPriceList () {
      let _this = this
      axios.get('/api/web/price/list?fileType=' + (this.fileType || '') + '&reportType=' + (this.reportType || '')).then(resp => {
        _this.priceList = resp.data
        if (_this.priceList) {
          _this.payForm.tableId = _this.priceList[0].id
          _this.curPrice = _this.priceList[0]
        }
      })
    },
    toPay () {
      // eslint-disable-next-line no-undef
      _hmt.push(['_trackEvent', '点击事件', '支付按钮'])

      let _this = this
      if (this.payForm.isInvoiceOrnot === '1') {
        this.payForm.invoiceInfoDtoStr = JSON.stringify(this.invoiceForm)
      }
      this.payForm.reportId = this.reportId

      axios.post('/api/order/yty/create', this.payForm).then(resp => {
        // 处理支付宝
        _this.ercodeContent = resp.data
        _this.iframeUrl = '/api/order/csmar/aliErcoe/' + _this.ercodeContent.data
        var aliWin
        // if (_this.ercodeContent.type === 'url') {
        //   // aliWin = window.open('/api/order/csmar/aliErcoe/' + _this.ercodeContent.data)
        //   _this.iframeUrl
        // } else {

        // }
        _this.ercodeDialogVisible = true
        if (_this.orderTimer) {
          clearInterval(_this.orderTimer)
          _this.orderTimer = null
        }
        _this.orderTimer = setInterval(() => {
          axios.get('/api/order/yty/info/' + _this.ercodeContent.orderId).then(resp => {
            if (resp.data && resp.data.orderStatus === 'FINISH') {
              if (_this.reportId) {
                clearInterval(_this.orderTimer)
                _this.orderTimer = null
                _this.ercodeDialogVisible = false
                _this.$store.commit('paySucsess')
                _this.$store.commit('toFreshUserPrice')
              } else {
                window.location.reload()
              }
              if (aliWin) {
                aliWin.close()
              }
            }
            if (resp.data && resp.data.orderStatus === 'FAIL') {
              clearInterval(_this.orderTimer)
              _this.orderTimer = null
              _this.$message.error('支付失败，请重试')
              _this.ercodeDialogVisible = false
              if (aliWin) {
                aliWin.close()
              }
            }
          })
        }, 3000)
      })
    }
  }
}
</script>
<style >
</style>



// WEBPACK FOOTER //
// src/components/pay.vue